import { ReactElement } from 'react';
import CasHardwareType from '@cas/components/asset-data/cas-hardware-type/CasHardwareType';
import ElementList from '../element-list/ElementList';

interface DeviceTypeCellRendererProps {
  value?: string;
}

export function DeviceTypeCellRenderer({
  value,
}: DeviceTypeCellRendererProps): ReactElement | null {
  return value ? (
    <ElementList>
      <CasHardwareType hardwareType={value} />
    </ElementList>
  ) : null;
}

export default DeviceTypeCellRenderer;
